import { getFetch } from '../fetch';
import { apiConfig } from '../config';

interface DiagnosticsResultsRequest {
    team_id: number;
    slug: string;
}

type DiagnosticsResultsBasePart = {
    file_id: string;
    slug: string;
    is_new_teacher?: boolean;
    dt_from?: number;
};

type DiagnosticsResultsFinalPart = {
    team_result: {
        sections: {
            name: string;
            progress: number | null;
            groups: {
                name: string;
                progress: number | null;
                skills: {
                    description: string;
                    name: string;
                    progress: number | null;
                }[];
            }[];
        }[];
    };
    student_results: {
        full_name: string;
        sections: {
            [section in string]?: {
                progress: number | null;
                groups: {
                    [group in string]?: {
                        progress: number | null;
                        skills: {
                            [skill in string]?: 0 | 1 | boolean | null;
                        };
                    };
                };
            };
        };
    }[];
};

type DiagnosticsEmptyPart = {
    team_result?: undefined;
    student_results?: undefined;
};

export type DiagnosticsResultsResponse =
    DiagnosticsResultsBasePart & (DiagnosticsResultsFinalPart | DiagnosticsEmptyPart);


export function getDiagnosticsResults(
    request: DiagnosticsResultsRequest
): Promise<DiagnosticsResultsResponse> {
    const { apiGetDiagnosticsResults } = apiConfig.getStaticUrls();

    return getFetch(apiGetDiagnosticsResults, request);
}
